import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface PaymentCardState {
  type: string,
  status: string,
  details: string,
  createdFor: string,
  createdBy: string,
  validTill: string,
  channelId: string,
}

const initialState: PaymentCardState = {
  type: "",
  status: "",
  details: "",
  createdFor: "",
  createdBy: "",
  validTill: "",
  channelId: "",
}

export const paymentCardSlice = createSlice({
  name: 'paymentCard',
  initialState,
  reducers: {
    setdata: (state, action: PayloadAction<PaymentCardState>) => {
      state.type = action.payload.type
      state.status = action.payload.status
      state.details = action.payload.details
      state.createdFor = action.payload.createdFor
      state.createdBy = action.payload.createdBy
      state.validTill = action.payload.validTill
      state.channelId = action.payload.channelId
    },
    reset: (state) => {
      state.type = initialState.type
      state.status = initialState.status
      state.details = initialState.details
      state.createdFor = initialState.createdFor
      state.createdBy = initialState.createdBy
      state.validTill = initialState.validTill
      state.channelId = initialState.channelId
    },
  },
})

// Action creators are generated for each case reducer function
export const { reset, setdata } = paymentCardSlice.actions

export default paymentCardSlice.reducer